import { Component, Input } from '@angular/core';
import { IActionButtonData } from './IActionButtonData.model';
import { MaterialModule } from 'src/app/material.module';
import { ThrottleTimeDirective } from '@core/directives/throttle-time.directive';

@Component({
  selector: 'cgw-action-button',
  standalone: true,
  imports: [MaterialModule, ThrottleTimeDirective],
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
})
export class ActionButtonComponent {
  @Input() data: IActionButtonData;

  public onClick(): void {
    if (this.data?.action) {
      this.data.action(this.data.product);
    }
  }
}
